<template>
  <v-sheet class="pa-0 ma-0" height="100%" width="100%">
    <v-container fluid class="fill-height pa-0 ma-0 d-flex flex-column">
      <v-row align="center" justify="center" class="pt-4">
        <v-img
          src="@/assets/fundo_conduril.png"
          contain
          max-width="150"
        />
      </v-row>

      <v-card flat class="pa-4 d-flex flex-column fill-height mt-4" style="overflow: hidden">
        <v-card-title class="justify-center text-h5 font-weight-bold">
          <v-icon large color="warning" class="mr-2">mdi-trophy-award</v-icon>
          Hall Of Fame
        </v-card-title>

        <v-card-text class="mt-4 text-center flex-grow-1">
          <div class="text-subtitle-1 font-italic mb-6">
            Projeto fundado a <strong>09/09/2021</strong>
          </div>

          <div class="text-h6 font-weight-bold mb-2">Principais Contributos</div>
          <!--<v-list class="mx-2" max-width="300" dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Manuel Sousa Marques</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Alfredo Costa Pinto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>José Filipe da Silva Amaral</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>-->
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <v-card-actions class="justify-center">
          <v-btn color="error" @click="$emit('close')">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-sheet>
</template>


  
  <script>
  export default {
    name: "HallOfFame",
  };
  </script>
  